<script>
import { mapState } from "vuex";

import moment from "@/utils/moment";

export default {
  computed: {
    ...mapState("payable", ["payable"])
  }
};
</script>

<template>
  <div class="header">
    <div class="left">
    <img class="cart" src="/static/carrinho.svg" />

    <div class="header-text">FINALIZAR COMPRA</div>
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

.left {
  height: 100%;
  display: flex;
  align-items: center;
}

.cart {
  height: 30px;
}

.header-text {
  margin-left: 8px;
  font-size: 20px;
  font-weight: 400;
  text-align: end;
}

@media (min-width: 580px) {
  .cart {
    height: 38px;
  }
  .header-text {
    font-size: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payable/CycleComponents/Header.vue